export type Captcha = { a: number; b: number; op: "+" | "-" | "*"; answer: number };

export function makeCaptcha(): Captcha {
  const ops: Captcha["op"][] = ["+", "-", "*"];
  const op = ops[Math.floor(Math.random() * ops.length)] as Captcha["op"];
  const a = op === "*" ? 2 + Math.floor(Math.random() * 8) : 3 + Math.floor(Math.random() * 20);
  const b = op === "*" ? 2 + Math.floor(Math.random() * 8) : 1 + Math.floor(Math.random() * 9);
  const answer = op === "+" ? a + b : op === "-" ? a - b : a * b;
  return { a, b, op, answer };
}
